import "../../styles/FAQSection.css";

import Label from "../atoms/Label";
import React, { useState } from "react";
import ic_faq from "../../assets/ic_faq.svg";
import ic_faq_text from "../../assets/ic_faq_text.svg";

const FAQSection = ({ faqData }) => {
	const [expandedItems, setExpandedItems] = useState({});

	const toggleFAQ = (index) => {
		setExpandedItems((prevState) => ({
			...prevState,
			[index]: !prevState[index]
		}));
	};

	return (
		<div className='faq-container'>
			<Label style={{ width: "100%", display: "flex", justifyContent: "left", marginLeft: "50px" }} label='Frequently Asked Questions' fontSize={"25px"} color={"#FFFFFF"} fontWeight={"700"} textAlign='left' />
			<div className='faq-list'>
				{faqData?.map((faq, index) => (
					<div key={index} className='faq-item'>
						<div 
							className='faq-question' 
							onClick={() => toggleFAQ(index)}
						>
							<span className={`arrow ${expandedItems[index] ? 'expanded' : ''}`}>›</span>
							{faq.question}
						</div>
						{expandedItems[index] && (
							<div className='faq-answer'>
								{faq.answer}
							</div>
						)}
					</div>
				))}
			</div>
			<div className='faq-images'>
				<img src={ic_faq_text} alt='FAQ Text' className='faq-text' />
				<img src={ic_faq} alt='FAQ Icon' className='faq-icon' />
			</div>
		</div>
	);
};

export default FAQSection;
